import React, { useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import ErrorPage from 'next/error';
import Event from '../../endpoints/Event/Event';
import ContentGrid from '../../grids/ContentGrid';
import Sidebar from '../../components/Sidebar/Sidebar';
import fetcher from '../../utils/fetcher';
import EVENTQUERY from '../../endpoints/Event/EventQuery';
import { parseEmbeddedAssets } from '../../utils/utils';
import '/public/css/pages/event.css';
import AdCategoriesContext from 'context/AdCategoriesContext';

const EventPage = ({ data, errorCode }) => {
  const context = useContext(AdCategoriesContext);
  if (errorCode) return <ErrorPage statusCode={errorCode} />;

  useEffect(() => {
    if (data.event.primaryCollection) {
      context.setPrimaryCategory(
        data.event?.primaryCollection.canonicalSlug || 'ros'
      );
    }
    if (data.event.collections) {
      context.setAdCategories(
        data.event?.collections.map((coll) => coll.canonicalSlug)
      );
    }
  }, [data.canonicalSlug]);

  return (
    <>
      <ContentGrid
        className="story-content-grid"
        sidebar={<Sidebar pageTopic={data.event.title} />}
      >
        <div id="mainContent"></div>
        <Event data={data} />
      </ContentGrid>
    </>
  );
};

EventPage.getInitialProps = async ({
  query: { slug, previewToken },
  req,
  res,
}) => {
  let memberDriveData;
  if (req) {
    memberDriveData = res.memberDriveData;
  }
  let data,
    errorCode,
    layout = 'default';

  await fetcher(EVENTQUERY, {
    contentAreaSlug: process.env.CONTENT_AREA_SLUG,
    slug: slug.join('/'),
    previewToken: previewToken,
  })
    .then((result) => {
      data = result;
      if (data?.event?.embeddedAssets) {
        parseEmbeddedAssets(data.event.embeddedAssets);
      }

      if (res) {
        res.setHeader('Cache-Control', 'public, max-age=60');
      }

      if (
        res &&
        data?.event?.canonicalSlug &&
        data.event.canonicalSlug !== slug.join('/')
      ) {
        res.writeHead(301, {
          Location: `/event/${data.story.canonicalSlug}`,
        });
        res.end();
      }
    })
    .catch((e) => {
      console.error('error', e);
      if (res) {
        res.statusCode = 404;
        errorCode = res.statusCode > 200 ? res.statusCode : false;
      }
    });

  return {
    data,
    errorCode,
    memberDriveData,
    layout,
    resourceType: data?.event?.resourceType,
  };
};

EventPage.propTypes = {
  errorCode: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
  data: PropTypes.object,
};

export default EventPage;
